import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { boxStyles } from '../Box/styles.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { spacing } from '../constants/spacing.js';

var labelIsAnimated = /*#__PURE__*/css(["font-size:", ";padding-bottom:2px;"], px2rem(12));
var counter = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__counter",
  componentId: "sc-1p3f38j-0"
})(["", ";color:", ";display:", ";overflow:hidden;text-align:right;vertical-align:top;font-size:", ";margin-left:", ";"], fontFamilyStyles, function (props) {
  return props.$over ? props.theme.inputField.web.error : props.theme.inputField.web.placeholder;
}, function (p) {
  return p.$error ? 'none' : 'inline-block';
}, px2rem(16), spacing.xxxs);
var label = /*#__PURE__*/styled.label.withConfig({
  displayName: "styles__label",
  componentId: "sc-1p3f38j-1"
})(["", ";background-color:", ";text-align:left;color:", ";font-size:", ";left:0;overflow:hidden;padding:", ";margin-left:", ";margin-right:", ";pointer-events:none;position:absolute;right:8px;text-overflow:ellipsis;top:", ";transition:color ", ",font-size ", ",padding-bottom ", ";transition-timing-function:", ";white-space:nowrap;z-index:2;"], fontFamilyStyles, function (p) {
  return p.theme.inputField.web.background;
}, function (p) {
  return p.theme.inputField.web.textColor;
}, function (p) {
  return p.theme.textarea.web.sizings[p.$size].fontSize;
}, function (p) {
  return toPaddingString(p.theme.textarea.web.label.padding);
}, px2rem(2), px2rem(2), px2rem(2), styles.transition.timing.slower, styles.transition.timing.slower, styles.transition.timing.slower, styles.transition["function"].base);
function toPaddingString(padding) {
  if (!padding) {
    return undefined;
  }
  return [padding.top || 0, padding.right || 0, padding.bottom || 0, padding.left || 0].join(' ');
}
var textarea = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "styles__textarea",
  componentId: "sc-1p3f38j-2"
})(["", ";box-sizing:border-box;background:", ";outline:none;-webkit-appearance:none;border-color:", ";border-style:solid;border-width:", ";border-radius:", ";color:", ";font-size:", ";overflow-y:auto;padding:", ";resize:vertical;transition:border ", ";transition-timing-function:", ";width:100%;", " ", " ", " ", " ", " scrollbar-width:thin;scrollbar-color:", ";&::-webkit-scrollbar{background:transparent;width:", ";}&::-webkit-scrollbar-track{background:transparent;box-shadow:none;}&::-webkit-scrollbar-thumb{background-color:", ";border:", " solid ", ";box-shadow:none;border-radius:", ";}"], fontFamilyStyles, function (p) {
  return p.theme.inputField.web.background;
}, function (p) {
  return p.theme.inputField.web.inactive;
}, px2rem(2), function (p) {
  return p.theme.borders.radius;
}, function (p) {
  return p.theme.inputField.web.textColor;
}, function (p) {
  return p.theme.textarea.web.sizings[p.$size].fontSize;
}, function (p) {
  return toPaddingString(p.theme.textarea.web.padding);
}, styles.transition.timing.slowest, styles.transition["function"].base, function (props) {
  return !props.disabled && css(["&:hover{border-color:", ";}"], props.$color);
}, function (props) {
  return !props.$empty && css(["+ ", "{color:", ";font-weight:", ";", "}"], label, function (p) {
    return p.theme.inputField.web.label.color;
  }, function (p) {
    return p.theme.inputField.web.label.fontWeight;
  }, labelIsAnimated);
}, function (props) {
  return props.$disabledStyle && css(["background:", ";border-color:", ";color:", ";cursor:not-allowed;resize:none;+ ", "{color:", ";background:", ";}"], function (p) {
    return p.theme.inputField.web.disabled.background;
  }, function (p) {
    return p.theme.inputField.web.disabled.label;
  }, function (p) {
    return p.theme.inputField.web.disabled.color;
  }, label, function (p) {
    return p.theme.inputField.web.disabled.label;
  }, function (p) {
    return p.theme.inputField.web.disabled.background;
  });
}, function (props) {
  return props.readOnly && css(["background:transparent;border-color:transparent;resize:none;&:hover{background:transparent;border-color:transparent;resize:none;}"]);
}, function (props) {
  return !props.readOnly && !props.disabled && css(["&:focus{border-color:", ";+ ", "{", ";color:", ";}}"], props.$color, label, labelIsAnimated, props.$color);
}, function (p) {
  return "".concat(p.$color, " ").concat(p.theme.inputField.web.background);
}, px2rem(8), function (props) {
  return props.$color;
}, px2rem(2), function (props) {
  return props.theme.listItems.web.background;
}, function (p) {
  return p.theme.borders.radius;
});
var field = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__field",
  componentId: "sc-1p3f38j-3"
})(["position:relative;", " ", ";"], function (props) {
  return props.$error && css(["", "{&:not(:focus){border-color:", ";}}"], textarea, props.$errorColor);
}, boxStyles);

export { counter, field, label, textarea };
